<template>
  <div class="pcm-wrapper-b" id="pcm-b-wrapper">
    <!-- 背景 -->
    <img class="pcm-b-bg" src="@/assets/images/pc/b/bg.webp" alt="" />

    <!-- 轮播人物：渐入渐出交叉淡入（底层常驻 + 顶层淡入） -->
    <img class="pcm-b-state pcm-b-state-base" :src="states[baseIdx]" alt="" />
    <img
      class="pcm-b-state pcm-b-state-top"
      :src="states[topIdx]"
      :style="{ opacity: topOpacity }"
      alt=""
    />

    <!-- 顶栏 logo -->
    <img
      class="pcm-b-abs"
      src="@/assets/images/pc/b/logo.webp"
      :style="posStyle(layout.logo)"
      alt=""
    />

    <!-- slogan / 卖点 -->
    <img
      class="pcm-b-abs"
      src="@/assets/images/pc/b/slogan.webp"
      :style="posStyle(layout.slogan)"
      alt=""
    />

    <!-- 扫码下载卡片 -->
    <img
      class="pcm-b-abs"
      src="@/assets/images/pc/b/qrbox.webp"
      :style="posStyle(layout.qrbox)"
      alt=""
    />
    <!-- 二维码（动态生成，覆盖卡片中的空二维码框） -->
    <div class="pcm-b-qr" :style="posStyle(layout.qr)">
      <img :src="qrImg" alt="" />
    </div>
    <!-- 下载按钮点击热区 -->
    <div
      class="pcm-b-hotspot"
      :style="posStyle(layout.dl)"
      @click="onDownload($event)"
    ></div>

    <!-- 联系方式 -->
    <img
      v-for="(c, i) in layout.contacts"
      :key="'c' + i"
      v-show="contactUrls[i]"
      class="pcm-b-abs pcm-b-clickable"
      :src="c.img"
      :style="posStyle(c)"
      alt=""
      @click="toContact(contactUrls[i])"
    />
  </div>
</template>

<script>
import autofit from "autofit.js";
import { landingPageClick } from "@/utils/eventTracker";

export default {
  name: "PcB",
  props: ["qrImg", "configs"],
  computed: {
    contactUrls() {
      return [this.swUrl, this.qdUrl, this.tgUrl];
    }
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  data() {
    return {
      swUrl: "",
      qdUrl: "",
      tgUrl: "",
      potatoUrl: "",
      // 人物两套素材，交叉淡入切换
      states: [
        require("@/assets/images/pc/b/state1.webp"),
        require("@/assets/images/pc/b/state2.webp")
      ],
      baseIdx: 0,
      topIdx: 1,
      topOpacity: 0,
      xfadeTimer: null,
      layout: {
        logo: { left: 59, top: 17, w: 240 },
        slogan: { left: 1, top: 59, w: 1135 },
        qrbox: { left: 243, top: 641, w: 636 },
        qr: { left: 340, top: 751, w: 110, h: 110 },
        dl: { left: 484, top: 838, w: 300, h: 70 },
        contacts: [
          {
            left: 1307,
            top: 24,
            w: 185,
            h: 70,
            img: require("@/assets/images/pc/b/btn-ggsw.webp")
          },
          {
            left: 1491,
            top: 24,
            w: 184,
            h: 70,
            img: require("@/assets/images/pc/b/btn-qdhz.webp")
          },
          {
            left: 1675,
            top: 24,
            w: 184,
            h: 70,
            img: require("@/assets/images/pc/b/btn-gfsq.webp")
          }
        ]
      }
    };
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-b-wrapper",
        resize: true
      },
      false
    );
    this.states.forEach(src => {
      new Image().src = src;
    });
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    posStyle(o) {
      const s = {
        left: o.left + "px",
        top: o.top + "px",
        width: o.w + "px"
      };
      if (o.h != null) s.height = o.h + "px";
      return s;
    },
    startRotation() {
      this.stopRotation();
      this.xfadeTimer = setInterval(() => {
        const next = (this.baseIdx + 1) % this.states.length;
        this.topIdx = next;
        this.topOpacity = 0;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.topOpacity = 1;
          });
        });
        setTimeout(() => {
          this.baseIdx = next;
          this.topOpacity = 0;
        }, 850);
      }, 3000);
    },
    stopRotation() {
      if (this.xfadeTimer) {
        clearInterval(this.xfadeTimer);
        this.xfadeTimer = null;
      }
    },
    onDownload(event) {
      this.$emit("getApkInfo", "android");
      if (event) {
        landingPageClick(this, {
          tab_name: "下载按钮",
          tab_key: "download",
          click_coordinates_x: event.clientX,
          click_coordinates_y: event.clientY
        });
      }
    },
    toContact(url) {
      if (url) window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-wrapper-b {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: #2a1140;
  .pcm-b-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    pointer-events: none;
  }
  .pcm-b-state {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }
  .pcm-b-state-base {
    z-index: 1;
  }
  .pcm-b-state-top {
    z-index: 2;
    opacity: 0;
    transition: opacity 0.8s ease;
  }
  .pcm-b-abs {
    position: absolute;
    z-index: 5;
    pointer-events: none;
  }
  .pcm-b-clickable {
    z-index: 11;
    cursor: pointer;
    pointer-events: auto;
  }
  .pcm-b-qr {
    position: absolute;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .pcm-b-hotspot {
    position: absolute;
    z-index: 11;
    cursor: pointer;
  }
}
</style>
